import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_SideBar = _resolveComponent("SideBar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", {
    class: "flex flex-col min-h-screen",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.pageClick && _ctx.pageClick(...args)))
  }, [
    (_ctx.store.getters['auth/authenticated'])
      ? (_openBlock(), _createBlock(_component_Header, {
          key: 0,
          class: "z-20 fixed"
        }))
      : _createCommentVNode("", true),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-100",
      "enter-from-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-from-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.store.getters['auth/authenticated'] && _ctx.store.getters['config/isDropDown'])
          ? (_openBlock(), _createBlock(_component_SideBar, {
              key: 0,
              class: "h-100 fixed z-10 md:pt-20 w-full tablet:w-60"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_openBlock(), _createBlock(_component_router_view, {
      key: _ctx.$route.path,
      class: _normalizeClass([{'mt-20 tablet:ml-60':_ctx.store.getters['auth/authenticated']}, "h-full"])
    }, null, 8, ["class"])),
    (_ctx.store.getters['auth/authenticated'])
      ? (_openBlock(), _createBlock(_component_Footer, {
          key: 1,
          class: "mt-auto tablet:ml-60"
        }))
      : _createCommentVNode("", true)
  ]))
}